import fetchJSONP from "fetch-jsonp";

export function getConfigJobsData() {
  return fetchJSONP(
    "https://jlwebapp.58.com/resumepost/targetCateIDs"
  ).then(res => res.json());
}

export function getConfigOtherData() {
  return fetchJSONP(
    "https://jlwebapp.58.com/resumepost/staticData"
  ).then(res => res.json());
}


// WEBPACK FOOTER //
// ./src/module/basic/api/configData.js